export default __webpack_public_path__ + "static/media/4-1.7f5588ad.png";